import { render, staticRenderFns } from "./HistoryActivityModal.vue?vue&type=template&id=2ab2864c&scoped=true&"
import script from "./HistoryActivityModal.vue?vue&type=script&lang=js&"
export * from "./HistoryActivityModal.vue?vue&type=script&lang=js&"
import style0 from "./HistoryActivityModal.vue?vue&type=style&index=0&id=2ab2864c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab2864c",
  null
  
)

export default component.exports